import React, { useState } from 'react';
import {FormComponent} from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';
import { read } from 'fs';

const ReBannerWarningComponent = ({
  document,
  fieldValue,
  template,
  fieldName,
  formParameters,
  key,
  responsiveLayouts,
  message,
  componentDefinition
}) => {

  const [value, setValue] = useState();

  // useEffect(() => {
  //   if (fieldValue) {
  //     setValue(fieldValue);
  //   } else if (componentDefinition.defaultValue) {
  //     setValue(componentDefinition.defaultValue);
  //   }
  // }, []);

  // react styles are specified in an object rather than a string so the values can be modified programmatically
  const warningStyle = {
    margin: "-6px 0px 0px -6px",
    position: "relative",
    fontSize: "1.5em",
    color: "red" 
  };

  const textStyle = {
    backgroundColor: componentDefinition?.color || "red",
    color:"black",
    fontWeight:"bold",
    fontSize:"2.0em",
    textAlign:"center"
  };

  return (
    <div>
      <div className='backgroundCircleLeft'>        
        <span 
          style={warningStyle} // refers to the warningStyle object above
          className='material-icons'>warning</span>
      </div>
      <div className='backgroundCircleRight'>
        <span style={warningStyle} className='material-icons'>warning</span>
      </div>
      <div style={textStyle}> 
        {componentDefinition?.text}
      </div>
    </div>
  );
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('re-banner-warning', ReBannerWarningComponent);

export default ReBannerWarningComponent;
